import { useState, useEffect } from 'react';
import { settingService, Setting } from '../services/settingService';
import { LEGACY_CALL_OUTCOME_VALUES } from '../constants/callOutcomes';

export interface CallOutcomeOption {
  value: string;
  label: string;
}

function mapSettingsToOptions(rows: Setting[]): CallOutcomeOption[] {
  return [...rows]
    .filter((s) => s.is_active)
    .sort((a, b) => (a.display_order ?? 0) - (b.display_order ?? 0))
    .map((s) => ({
      value: s.setting_value,
      label: s.display_name || s.setting_value,
    }));
}

export function useCallOutcomeOptions(): { options: CallOutcomeOption[]; loading: boolean } {
  const [options, setOptions] = useState<CallOutcomeOption[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const rows = await settingService.getByType('call_outcome');
        const mapped = mapSettingsToOptions(rows || []);
        if (!cancelled) {
          setOptions(
            mapped.length > 0
              ? mapped
              : LEGACY_CALL_OUTCOME_VALUES.map((v) => ({ value: v, label: v }))
          );
        }
      } catch {
        if (!cancelled) {
          setOptions(LEGACY_CALL_OUTCOME_VALUES.map((v) => ({ value: v, label: v })));
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { options, loading };
}
